var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c("v-col", { attrs: { cols: "10" } }, [
            _c("h1", [_vm._v(_vm._s(_vm.$t("optima.title")))])
          ]),
          _c("v-spacer"),
          _c(
            "v-tooltip",
            {
              attrs: { top: "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on
                    return [
                      _c(
                        "v-btn",
                        _vm._g(
                          {
                            attrs: { large: "", icon: "" },
                            on: {
                              click: function($event) {
                                return _vm.$router.push(
                                  "/optima/settings/category"
                                )
                              }
                            }
                          },
                          on
                        ),
                        [
                          _c("v-icon", { attrs: { "x-large": "" } }, [
                            _vm._v("fa-cog")
                          ])
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            },
            [_vm._v(" " + _vm._s(_vm.$t("global.settings")) + " ")]
          )
        ],
        1
      ),
      _c(
        "v-form",
        { ref: "form", attrs: { "lazy-validation": "" } },
        [
          _c("select-delegation-by-criteria-component", {
            attrs: {
              delegation_ids: _vm.delegation_ids,
              "get-delegations-address": "/optima/get-delegations",
              "get-filter-data-address": "/optima/get-filters-data"
            },
            on: {
              "update:delegation_ids": function($event) {
                _vm.delegation_ids = $event
              }
            },
            scopedSlots: _vm._u([
              {
                key: "action",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c(
                      "v-tooltip",
                      {
                        attrs: { top: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      {
                                        attrs: { icon: "" },
                                        on: {
                                          click: function($event) {
                                            return _vm.downloadDelegation(
                                              item.id
                                            )
                                          }
                                        }
                                      },
                                      on
                                    ),
                                    [
                                      _c("v-icon", [
                                        _vm._v("mdi-file-download")
                                      ])
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("global.downloadFile")) + " "
                        )
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _c(
            "v-row",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                { staticClass: "accent", on: { click: _vm.generate } },
                [_vm._v(_vm._s(_vm.$t("optima.generate")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }